// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-36392a70] .el-badge__content.is-fixed{\n  top:10px;\n  right: 15px;\n}\n.item[data-v-36392a70]{\n    margin-right: 20px;\n}\n", ""]);
